<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">搜索配置</h3>

      <Row class="row" >
        <Col span="8">搜索类</Col>
        <Col span="6">code</Col>
        <Col span="6">操作</Col>
      </Row>
      <Row class="row" v-for="(item,index) in data " :key="item.fid">
        <Col span="8">
          <Input class="width150" :maxlength="50" v-model="item.labelName"/>
        </Col>
        <Col span="6">
          <Input class="width150" :maxlength="50" v-model="item.labelCode"/>
        </Col>
        <Col span="6">
          <a @click.stop="deleteItem(item,index)">删除</a>
        </Col>
      </Row>
      <div class="mt20">
        <a @click.stop="addItem">+ 添加</a>
      </div>
      <div class="mt20">
        <a style="color: red">注code填写规则:101:独立卫生间，102:深呼吸，103:可养宠物,104:独立阳台,105:支持长租,106:支持短租,107:精选软装房,
        108:新风系统,109:视频看房,201:展示的标签，名称|隔开</a>
      </div>
    </Modal>
  </div>

</template>

<script>
  import {labellist,labelremove,labeledit} from "api/projectConfig";

  export default {
    name: "SearchTag",
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      houseTypeFid:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        this.getLabellist()
        this.isShow=true
      },
    },
    data(){
      return {
        isShow:false,
        data:[],
        loading:true
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      addItem(){
        this.data.push({
          "fid": "",
          "labelName": "",
          "labelCode": "",
          "moduleId": this.houseTypeFid,
          "labelType":2
        })
      },
      getLabellist(){
        if(!this.houseTypeFid){
          return
        }
        var params={
          moduleFid:this.houseTypeFid,
          type:2
        }
          labellist(params).then(res=>{
          this.data=res.data
        })

      },
      deleteItem(item,index){

        this.$Modal.confirm({
          content: '<p>确认删除？</p>',
          onOk: () => {
            if(item.fid){
              let params={
                fid:item.fid
              }
                labelremove(params).then(res=>{
                this.$Message.success('删除成功')
                this.getLabellist()
              })
            }
            else {
              this.data.splice(index,1)
            }
          }
        })
      },
      ok(){
        var isNull=false
        this.data.forEach(ele=>{
          if( !ele.labelName||!ele.labelCode){
            isNull=true
          }
        })

        if(isNull){
          this.$Message.info('名称，code不能为空！')
          this.changeLoading()
          return
        }

        var params={
          moduleFid:this.houseTypeFid,
          labelEntities:this.data,
          proHouseTypeFid:this.houseTypeFid,
          type:2
        }
          labeledit(params).then(res=>{
              this.getLabellist()
          this.$Message.success('保存成功')
        }).catch(err=>{}).finally(()=>{
            this.changeLoading()
          })
      },

    },
    created(){
    }

  }
</script>

<style scoped>
  .width150{
    width: 100px;
  }
  .width80{
    width: 50px;
  }
  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;

    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

</style>
